import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AddItem from './ItemDetails/AddItem';
import DeleteItem from './ItemDetails/DeleteItem';
import UpdateItem from './ItemDetails/UpdateItem';
import MappingList from './DentiraMapping/MappingList';
import AddMapping from './DentiraMapping/AddMapping';
import BulkOperations from './BulkOperations';

import {
	RootContainer,
	TitleSection,
	TitleRow,
	Title,
	FlexRow,
	FlexColumn,
	Search,
	ButtonGroup,
	SubtitleSection,
	SubtitleRow,
	Note,
	Emphasis,
	Highlight,
	Warning,
	TableContainer,
	Table,
	TableHeader,
	TableHeaderRow,
	TableHeaderColumn,
	TableBody,
	TableRow,
	TableColumn,
	TablePagination,
	NotFound,
	CircularProgress,
	SubHeading,
	Message,
	NoWrapText,
} from '../../Styles';
import { TitleColumn, FiltersColumn, DetailsColumn, ItemID, ItemName } from './styles';

import { fetchInventoryItems, fetchBucketList } from '../../../actions/inventoryActionsV2';
import { formatCurrency } from '../../../commons/utils';
import { changeTile } from '../../../actions/changeTile';
import { Box, Switch } from '@mui/material';

const Inventory = (props) => {
	const { supplier, disableSingleInventoryMapping, disableSingleInventoryUpdate, disableSingleInventoryDelete, buckets } = props;
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [pageSize, setPageSize] = useState(10);
	const [pageNumber, setPageNumber] = useState(0);
	const [inventory, setInventory] = useState({});
	const [filters, setFilters] = useState({
		noMapping: false
	});
	const { products: items, totalResults: count } = inventory || {};

	const fetchInventoryItems = async () => {
		setLoading(true);

		setInventory(
			await props.fetchInventoryItems({
				page: pageNumber + 1,
				size: pageSize,
				search: searchText,
				filters
			})
		);

		setLoading(false);
	};

	useEffect(() => {
		fetchInventoryItems();
	}, [supplier, pageNumber, pageSize, searchText, filters]);

	useEffect(() => {
		setPageNumber(0);
	}, [supplier, pageSize, searchText]);

	useEffect(() => {
		setSearchText('');
	}, [supplier]);

	useEffect(() => {
		if (!buckets || buckets.length === 0) {
			props.fetchBucketList();
		}
	}, [supplier]);

	useEffect(() => {
		const { history, tile } = props;
		const { changeTile } = props;

		if (tile !== 'INVENTORY' || history.action === 'POP') {
			changeTile('INVENTORY');
		}
	}, []);

	const renderMappingStatus = (mappings) => {
		switch (mappings) {
			case 0:
				return <Warning>To Be Mapped</Warning>;
			case 1:
				return <Highlight>1 Mapping</Highlight>;
			default:
				return <Highlight>{mappings} Mappings</Highlight>;
		}
	};

	const renderDigitalOnly = (item) => {
		if ('digital_only' in item) {
			return item.digital_only ? 'Yes' : 'No';
		}
		return 'Not Set';
	};

	const renderArray = (item) =>{
	if (Array.isArray(item)) {
		try {
			return item.map(str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).join(', ');
		} catch (error) {
			return 'Any';
		}
	}
	return 'Any';
	}

	return (
		<RootContainer>
			<Helmet>
				<title>Seller Portal | Labs | Inventory</title>
			</Helmet>

			<TitleSection>
				<TitleRow responsive='1200px'>
					<TitleColumn>
						<FlexRow>
							<FlexColumn flex='auto'>
								<Title>Items</Title>
							</FlexColumn>
							<FlexRow style={{alignItems: 'center', marginRight: '1rem'}}>
								<Switch
									checked={filters.noMapping} 
									onChange={(e) => setFilters({ ...filters, noMapping: e.target.checked })}
								/>
								<NoWrapText>Show only unmapped SKUs</NoWrapText>
							</FlexRow>
							<FlexColumn flex='auto'>
								<FlexRow align='flex-end'>
									<Search
										searchText={searchText}
										placeholder={'Search'}
										enableDelayOnChange={true}
										searchOnChange={true}
										onSearchHandler={(value) => setSearchText(value)}
									/>
								</FlexRow>
							</FlexColumn>
						</FlexRow>
					</TitleColumn>

					<FiltersColumn>
						<FlexRow>
							<ButtonGroup alignRight>

								<AddItem refresh={() => fetchInventoryItems()} />

								<BulkOperations
									refreshing={loading}
									refresh={() => fetchInventoryItems()}
								/>
							</ButtonGroup>
						</FlexRow>
					</FiltersColumn>
				</TitleRow>
			</TitleSection>

			{/* <SubtitleSection>
				<SubtitleRow responsive='1200px'> */}
					{/* <FlexColumn>
						<FlexRow align='flex-start'>
							<Note>All updates which require approval will reflect on Dentira website next business day if approved.</Note>
						</FlexRow>
					</FlexColumn>
				 	</SubtitleRow>
			</SubtitleSection> */}
			<Box sx={{
				width: 'calc(100vw - 250px)',
			}}>
				<TableContainer>
					<Table>
						<TableHeader>
							<TableHeaderRow>
								<TableHeaderColumn
									width={'40%'}
									minWidth={'18rem'}
								>
									Lab Product Name
								</TableHeaderColumn>
								<TableHeaderColumn
									width={'15%'}
									minWidth={'8rem'}
								>
									Case Type <br />(DGTL/ANG)
								</TableHeaderColumn>

								<TableHeaderColumn
									width={'15%'}
									minWidth={'8rem'}
								>
									Tooth Type <br />(ANT/POST)
								</TableHeaderColumn>


								<TableHeaderColumn
									width={'15%'}
									minWidth={'8rem'}
								>
									Base Price
								</TableHeaderColumn>

								{(buckets || []).map((bucket) => (
									<TableHeaderColumn
										key={`bucket-header-${bucket?.id || bucket?.value}`}
										width={'12%'}
										minWidth={'7rem'}
									>
										{(bucket?.alias ? String(bucket.alias).toUpperCase() : '')}
									</TableHeaderColumn>
								))}

								<TableHeaderColumn
									width={'15%'}
									minWidth={'8rem'}
								>
									Mapping Status
								</TableHeaderColumn>

								{!(disableSingleInventoryMapping && disableSingleInventoryUpdate && disableSingleInventoryDelete) && (
									<TableHeaderColumn
										alignRight
										minWidth='12rem'
										maxWidth='12rem'
									>
										Actions
									</TableHeaderColumn>
								)}
							</TableHeaderRow>
						</TableHeader>

						<TableBody>
							{loading ? (
								<TableRow key='loading'>
									<TableColumn colSpan={'100%'}>
										<CircularProgress showSpinner={loading} />
									</TableColumn>
								</TableRow>
							) : count ? (
								items.map((item, index) => (
									<TableRow key={index}>
										<TableColumn>
											<FlexRow>
												<DetailsColumn>
													<ItemName>{item?.name || ''}</ItemName>

													<ItemID>
														{item?.supplier_product_id || 'NA'} | {item?.manufacturer_id || 'NA'}
													</ItemID>
												</DetailsColumn>
											</FlexRow>
										</TableColumn>

										<TableColumn>
											<FlexRow>{renderArray(item?.caseTypeTags)}</FlexRow>
										</TableColumn>

										<TableColumn>
											<FlexRow>{renderArray(item?.toothTypeTags)}</FlexRow>
										</TableColumn>

										<TableColumn>
											<FlexRow>
												<Emphasis>{formatCurrency(item?.price || null, false, item?.is_alloy) || '-'}</Emphasis>
											</FlexRow>
										</TableColumn>

										{(buckets || []).map((bucket) => {
											const bucketId = bucket?.id || bucket?.value || bucket?.bucket_id;
											const priceForBucket = item?.[bucketId];
											return (
												<TableColumn key={`bucket-col-${bucketId}`}>
													<FlexRow>
														<Emphasis>{priceForBucket !== undefined ? formatCurrency(priceForBucket, false, item?.is_alloy) : '-'}</Emphasis>
													</FlexRow>
												</TableColumn>
											);
										})}

										<TableColumn>
											<FlexRow>{renderMappingStatus(item?.mappings)}</FlexRow>
										</TableColumn>

										<TableColumn alignRight>
											<FlexRow>
												<ButtonGroup alignRight>
													<MappingList
														item={item}
														refresh={() => fetchInventoryItems()}
													/>

													<UpdateItem
														itemId={item?.supplier_product_id}
														refresh={() => fetchInventoryItems()}
													/>

													<DeleteItem
														itemId={item?.supplier_product_id}
														refresh={() => fetchInventoryItems()}
													/>
												</ButtonGroup>
											</FlexRow>
										</TableColumn>
									</TableRow>
								))
							) : (
								<TableRow key='not-found'>
									<TableColumn colSpan={'100%'}>
										<NotFound lines={["Couldn't find any items"]} />

										<FlexRow>
											<ButtonGroup alignCenter>
												<AddItem refresh={() => fetchInventoryItems()} />
											</ButtonGroup>
										</FlexRow>
									</TableColumn>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			
			<TablePagination
				component='div'
				count={count || 0}
				page={pageNumber}
				onPageChange={(e, page) => {
					setPageNumber(parseInt(page, 10));
				}}
				rowsPerPage={pageSize}
				onRowsPerPageChange={(e) => {
					setPageNumber(0);
					setPageSize(parseInt(e.target.value, 10));
				}}
			/>
			</Box>
		</RootContainer>
	);
};

const mapStateToProps = (state) => {
	const supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	const userSellerPortalConfig = state.session.sellerPortalConfig || {};

	const disableSingleInventoryUpdate = supplierSellerPortalConfig.disable_single_inventory_update || userSellerPortalConfig.disable_single_inventory_update || false;
	const disableSingleInventoryDelete = supplierSellerPortalConfig.disable_single_inventory_delete || userSellerPortalConfig.disable_single_inventory_delete || false;
	const disableSingleInventoryMapping = supplierSellerPortalConfig.disable_single_inventory_mapping || userSellerPortalConfig.disable_single_inventory_mapping || false;

	return {
		supplier: state?.supplier?.supplier || '',
		disableSingleInventoryUpdate,
		disableSingleInventoryDelete,
		disableSingleInventoryMapping,
		buckets: state.inventory.buckets || [],
		bucketOrder: state.inventory.bucketOrder || []
	};
};

const mapDispatch = {
	changeTile,
	fetchInventoryItems,
	fetchBucketList,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(Inventory));
